"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonWithDropdown = exports.ButtonWithDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./ButtonWithDropdown.css");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var Button_1 = require("../../components/Button");
var Popover_1 = require("../../components/Popover");
(0, MDIcon_1.preloadIcons)("chevron-up", "chevron-down");
var ButtonWithDropdown = function (_a) {
  var _b = _a.expanded,
    expanded = _b === void 0 ? false : _b,
    _c = _a.doExpand,
    doExpand = _c === void 0 ? R.N : _c,
    className = _a.className,
    buttonType = _a.buttonType,
    buttonProps = _a.buttonProps,
    buttonContent = _a.buttonContent,
    _d = _a.withChevron,
    withChevron = _d === void 0 ? true : _d,
    onClick = _a.onClick,
    children = _a.children,
    _e = _a.placement,
    placement = _e === void 0 ? "bottom-start" : _e,
    _f = _a.closeOnClickOutside,
    closeOnClickOutside = _f === void 0 ? false : _f,
    restProps = __rest(_a, ["expanded", "doExpand", "className", "buttonType", "buttonProps", "buttonContent", "withChevron", "onClick", "children", "placement", "closeOnClickOutside"]);
  var expand = function (e) {
    onClick && onClick(e);
    doExpand && doExpand(!expanded);
  };
  var onClickOutside = function () {
    if (closeOnClickOutside) {
      doExpand(false);
    }
  };
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-dropdown-with-button", className, expanded && "expanded", !withChevron && "no-chevron")
  }, {
    children: (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
      customColor: "transparent",
      className: "vsx-dropdown",
      content: children,
      placement: placement,
      onClickOutside: onClickOutside,
      shown: expanded,
      contentStyle: {
        padding: 0
      },
      arrow: false,
      distance: 4
    }, {
      children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({}, buttonProps, {
        type: buttonType,
        onClick: expand
      }, {
        children: (0, jsx_runtime_1.jsxs)("div", __assign({
          style: {
            display: "flex"
          }
        }, {
          children: [(0, jsx_runtime_1.jsx)("span", {
            children: buttonContent
          }), withChevron && (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            className: "chevron",
            icon: expanded ? "chevron-up" : "chevron-down"
          })]
        }))
      }))
    }))
  }));
};
exports.ButtonWithDropdown = ButtonWithDropdown;
var IconButtonWithDropdown = function (_a) {
  var _b = _a.expanded,
    expanded = _b === void 0 ? false : _b,
    _c = _a.doExpand,
    doExpand = _c === void 0 ? R.N : _c,
    className = _a.className,
    _d = _a.outline,
    outline = _d === void 0 ? false : _d,
    _e = _a.round,
    round = _e === void 0 ? false : _e,
    icon = _a.icon,
    onClick = _a.onClick,
    _f = _a.placement,
    placement = _f === void 0 ? "bottom-start" : _f,
    children = _a.children,
    _g = _a.closeOnClickOutside,
    closeOnClickOutside = _g === void 0 ? false : _g,
    restProps = __rest(_a, ["expanded", "doExpand", "className", "outline", "round", "icon", "onClick", "placement", "children", "closeOnClickOutside"]);
  var expand = function (e) {
    onClick && onClick(e);
    doExpand && doExpand(!expanded);
  };
  var onClickOutside = function () {
    if (closeOnClickOutside) {
      doExpand(false);
    }
  };
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-dropdown-with-button", className, expanded && "expanded")
  }, {
    children: (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
      customColor: "transparent",
      className: "vsx-dropdown",
      content: children,
      placement: placement,
      onClickOutside: onClickOutside,
      shown: expanded,
      contentStyle: {
        padding: 0
      },
      arrow: false,
      distance: 4
    }, {
      children: (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        className: (0, classnames_1.default)("vsx-dropdown-button", expanded && "active"),
        icon: icon,
        cursor: "pointer",
        onClick: expand,
        round: round,
        outline: outline
      })
    }))
  }));
};
exports.IconButtonWithDropdown = IconButtonWithDropdown;